import Vue from 'vue'
import Router from 'vue-router'
import _ from 'lodash'
import store from '../store'

import AuthRoutes from '@/modules/auth/routes'
import AdminMatchesRoutes from '@/modules/admin-matches/routes'
import AdminUserRoutes from '@/modules/admin-users/routes'
import AdminSocietiesRoutes from '@/modules/admin-societies/routes'
import AdminRequestsRoutes from '@/modules/admin-requests/routes'
import AdminRequestsArchiveRoutes from '@/modules/admin-requests-archive/routes'
import AdminContactsRoutes from '@/modules/admin-contacts/routes'
import AdminMailingsRoutes from '@/modules/admin-mailings/routes'
import AdminNoticesRoutes from '@/modules/admin-notices/routes'

import SocietyDashRoutes from '@/modules/society-dash/routes'
import SocietyContactsRoutes from '@/modules/society-contacts/routes'
import SocietyMatchesRoutes from '@/modules/society-matches/routes'

const routes = _.concat(
    AuthRoutes,
    AdminMatchesRoutes,
    AdminUserRoutes,
    AdminSocietiesRoutes,
    AdminRequestsRoutes,
    AdminRequestsArchiveRoutes,
    AdminContactsRoutes,
    AdminMailingsRoutes,
    AdminNoticesRoutes,
    SocietyDashRoutes,
    SocietyContactsRoutes,
    SocietyMatchesRoutes
);


Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: '/',
    routes: routes
});

router.beforeEach((to, from, next) => {

    store.state.common.pageTitle = to.meta.pageTitle || '';
    store.state.common.breadcrumb = to.meta.breadcrumb;

    if(to.meta.requiresAuth && !store.getters.isLoggedIn) {
        next('/')
    }

    /** check for roles */
    if(store.state.auth.currentUser
        && store.state.auth.currentUser.status === 'pending'
        && !store.getters.isImpersonating
        && to.name !== 'auth.pending') {
        store.dispatch('authLogout', 'noRedirect');
        router.push({name : 'auth.pending'});
    }

    next();

});

export default router
